if (!customElements.get('mattress-collection-option')) {
  class MattressCollectionOption extends HTMLElement {
    constructor() {
      super();
      this.onChange = this.onChange.bind(this);
    }

    connectedCallback() {
      this.checkbox = this.querySelector('[data-mattress-collection-toggle]');
      this.checkbox?.addEventListener('change', this.onChange);
    }

    disconnectedCallback() {
      this.checkbox?.removeEventListener('change', this.onChange);
    }

    get variantId() {
      return this.dataset.variantId;
    }

    setLoading(isLoading) {
      document.querySelectorAll('mattress-collection-option').forEach((option) => {
        option.classList.toggle('is-loading', isLoading);
        const checkbox = option.querySelector('[data-mattress-collection-toggle]');
        if (checkbox) checkbox.disabled = isLoading;
      });

      document.querySelectorAll('button[name="checkout"], input[name="checkout"]').forEach((button) => {
        button.disabled = isLoading;
      });
    }

    setChecked(checked) {
      document.querySelectorAll('[data-mattress-collection-toggle]').forEach((checkbox) => {
        checkbox.checked = checked;
      });
    }

    setStatus(message = '', isError = false) {
      document.querySelectorAll('mattress-collection-option').forEach((option) => {
        option.classList.toggle('has-error', isError);
        const status = option.querySelector('[data-mattress-collection-status]');
        if (status) status.textContent = message;
      });
    }

    async onChange(event) {
      const shouldAdd = event.currentTarget.checked;
      this.setChecked(shouldAdd);
      this.setLoading(true);
      this.setStatus(shouldAdd ? 'Adding collection service…' : 'Removing collection service…');

      const sections = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', {
          bubbles: true,
          detail: { sections }
        })
      );

      const body = {
        updates: {
          [this.variantId]: shouldAdd ? 1 : 0
        },
        sections: [...new Set(sections)],
        sections_url: window.location.pathname
      };

      try {
        const response = await fetch(FoxTheme.routes.cart_update_url, {
          ...FoxTheme.utils.fetchConfig(),
          body: JSON.stringify(body)
        });

        const cart = await response.json();

        if (!response.ok || cart.errors) {
          const message = cart.description || cart.message || cart.errors || 'The basket could not be updated. Please try again.';
          throw new Error(typeof message === 'string' ? message : 'The basket could not be updated. Please try again.');
        }

        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart });
        this.setLoading(false);
        this.setStatus();
      } catch (error) {
        this.setChecked(!shouldAdd);
        this.setLoading(false);
        this.setStatus(error.message, true);
      }
    }
  }

  customElements.define('mattress-collection-option', MattressCollectionOption);
}
